import React from 'react';
export type ProcedureViewState = Map<number, { body: string; open: number[] }>;
export const ProcedureViewStateContext = React.createContext<ProcedureViewState | null>(null);
